<div fxFlex="100" class="inputs" fxLayout="row wrap">
    <app-edit-suggestion-field [isEditable]="isEditable" [label]="'Currency Code*'" [displayField]="'currency_code'"
        [name]="'currency_code'" [(ngModel)]="currencyObject.currency_code" (onSelect)="editCurrencyMaster($event)"
        [listUrl]="currencyMaster_url+'currency/?currency_code=::search::'" class="m1em" fxFlex="12em" fxLayout="column"
        [errors]="errorObj.currency_code">
    </app-edit-suggestion-field>

    <app-text-field [isMultiline]="true" [isEditable]="isEditable" [label]="'Description'"
        [(ngModel)]="currencyObject.description" [name]="'description'" class="ai-fxs m1em " fxFlex="12em"
        fxLayout="column" [errors]="errorObj.description">
    </app-text-field>

    <!-- <app-select-field fxFlex="26.4em" [isEditable]="isEditable" [label]="'Countries included*'"
        [(ngModel)]="currencyObject.countries" [name]="'countries'" [multiple]="true" [searchable]="true"
        [displayField]="'name'" [idField]="null" [options]="dd_country?.results" [errors]="errorObj.countries">
    </app-select-field> -->
    <app-mat-auto-search [isEditable]="isEditable" [label]="'Countries included*'" [name]="'countries'" [defaultChip]="false"
        [multiple]="true" [displayField]="'name'" [(ngModel)]="currencyObject.countries" [setSearchValue]="false"
        [idField]="null" fxFlex="26.4em" [listUrl]="currencyMaster_url+'currency_country/?name=::search::'"
        [errors]="errorObj.countries">
    </app-mat-auto-search>

    <div class="ai-fxs m1em" fxFlex="26.4em" fxLayout="column">
        <section>
            <mat-checkbox color="primary" [(ngModel)]="currencyObject.is_active" checked [disabled]="!isEditable" (click)="inActiveCurrencyMaster(currencyObject.is_active)">Active
            </mat-checkbox>
        </section>
    </div>
    <div fxFlex="100" class="btnb">
        <ng-container *ngIf="isEditable">
            <button mat-raised-button (click)="saveCurrency()" class="Save"> Save</button>
        </ng-container>
        <ng-container *ngIf="!isEditable">
            <button mat-raised-button (click)="wasEdit()" class="Save"> Edit</button>
        </ng-container>
    </div>
</div>